// src/api/aiService.js
// Servizio centralizzato per chiamare Cloud Functions AI + Firestore

import { getFunctions, httpsCallable } from "firebase/functions";
import { db, auth } from "../firebase";
import {
collection,
getDocs,
doc,
getDoc,
setDoc,
serverTimestamp,
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

const functions = getFunctions();

/* ----------------------------------------------------------
🔹 Recupera il localeTag del gestore loggato
---------------------------------------------------------- */
export const getLocaleTagCorrente = () =>
new Promise((resolve, reject) => {
onAuthStateChanged(auth, async (user) => {

try {

	const forcedLocale =
		localStorage.getItem("forcedLocale");

	if (forcedLocale) {
		resolve(forcedLocale);
		return;
	}

	if (!user) return reject(new Error("Nessun utente loggato"));

const utentiSnap = await getDocs(collection(db, "utenti"));
const mioUtente = utentiSnap.docs.find((d) => d.id === user.uid);

if (!mioUtente)
return reject(new Error("Utente non trovato in 'utenti'"));

const data = mioUtente.data();
const locali = data.locali || (data.localeTag ? [data.localeTag] : []);

if (!locali || !locali[0])
return reject(new Error("Nessun locale associato all’utente"));

resolve(locali[0]);
} catch (err) {
reject(err);
}
});
});

/* ----------------------------------------------------------
🔹 Carica il menu reale del locale (struttura: collection "menu")
---------------------------------------------------------- */
export const caricaMenuLocale = async (localeTag) => {
try {
const menu = [];
const snap = await getDocs(collection(db, "menu"));

snap.forEach((docSnap) => {
const data = docSnap.data();

// Filtra i piatti del locale
if (data.localeTag === localeTag) {
menu.push({
id: docSnap.id,
...data,
});
}
});

console.log(
`[AI] caricaMenuLocale: trovati ${menu.length} piatti per localeTag="${localeTag}"`
);

return menu;
} catch (err) {
console.error("Errore in caricaMenuLocale:", err);
return [];
}
};

// 🔹 Chiamata AI suggerimenti piatti
export const consigliaPiattoAI = async ({
  umore,
  menu,
  preferenze,
  localeTag,
}) => {
  const fn = httpsCallable(functions, "consigliaPiatto");

  const res = await fn({
    localeTag,
    umore,
    menu,
    preferenze,
  });

  return res.data;
};

// 🔹 Chiamata AI upselling / cross-selling
export const upsellingAI = async ({
  piatto,
  menu,
  localeTag,
}) => {

  const fn = httpsCallable(
    functions,
    "assistenteAbbinamentiAI"
  );

  const res = await fn({
    localeTag,
    menu,
    piattoBase: piatto,
    scenario: "upselling",
    preferenze: {},
  });

  return {
    risultato: {
      upselling:
        res.data?.suggerimenti?.[0] || null,

      cross_selling:
        res.data?.suggerimenti?.[1] || null,
    },
  };
};


/* ----------------------------------------------------------
🔹 Preferenze AI del locale
---------------------------------------------------------- */
export const salvaPreferenzeAI = async ({ localeTag, preferenze }) => {
const ref = doc(db, "ai_settings", localeTag);

await setDoc(
ref,
{
...preferenze,
updatedAt: serverTimestamp(),
},
{ merge: true }
);
};

export const caricaPreferenzeAI = async (localeTag) => {
const ref = doc(db, "ai_settings", localeTag);
const snap = await getDoc(ref);
return snap.exists() ? snap.data() : null;
};
